<!--begin::Topbar-->
<ng-container *ngIf="extrasNotificationsDisplay">
    <ng-container *ngIf="extrasNotificationsLayout === 'offcanvas'">
        <!--begin::Notifications-->
        <div class="topbar-item">
            <div class="btn btn-icon btn-icon-mobile btn-clean btn-lg mr-1 pulse pulse-primary"
                 id="kt_quick_notifications_toggle">
        <span [inlineSVG]="'./assets/media/svg/icons/Code/Compiling.svg'" cacheSVG="true"
              class="svg-icon svg-icon-xl svg-icon-primary"></span>
                <span class="pulse-ring"></span>
            </div>
        </div>
        <!--end::Notifications-->
    </ng-container>

    <ng-container *ngIf="extrasNotificationsLayout === 'dropdown'">
        <!--begin::Notifications-->
        <div class="dropdown" ngbDropdown placement="bottom">
            <!--begin::Toggle-->
            <div class="topbar-item" data-toggle="dropdown" data-offset="10px,0px" ngbDropdownToggle>
                <div class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse">
                    <span class="fas fa-bell notification-icon"></span>
                    <span class="fas fa-circle new-notification-icon" *ngIf="newNotification"></span>
                </div>
            </div>
            <!--end::Toggle-->

            <!--begin::Dropdown-->
            <div ngbDropdownMenu class="dropdown-menu p-0 m-0 dropdown-menu-anim-up dropdown-menu-lg">
                <app-notifications-dropdown-inner
                        (newNotif)="checkNotifications($event)"></app-notifications-dropdown-inner>
            </div>
            <!--end::Dropdown-->
        </div>
        <!--end::Notifications-->
    </ng-container>
</ng-container>


<ng-container *ngIf="extrasUserDisplay">
    <ng-container *ngIf="extrasUserLayout === 'offcanvas'">
        <!--begin::User-->
        <div class="topbar-item" id="kt_quick_user_toggle">
            <div class="btn btn-icon btn-icon-mobile w-auto btn-clean d-flex align-items-center btn-lg px-2"
                 *ngIf="userLoaded">
                <span class="greetings custom-font d-none d-md-inline mr-1">Hi,</span>
                <span class="logged-user-name custom-font d-none d-md-inline mr-3">{{ userInfo.firstName }}</span>
                <img src="{{userInfo.profileImagePath}}" alt="Profile" class="user-icon">
            </div>
        </div>
        <!--end::User-->
    </ng-container>
</ng-container>

<!--end::Topbar-->
